import { render, staticRenderFns } from "./change_management.vue?vue&type=template&id=486dfa51&"
import script from "./change_management.vue?vue&type=script&lang=js&"
export * from "./change_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports